/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'us.edriffles.radlib.private.createSyncGrant'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $input = /*#__PURE__*/ l.jsonPayload({
  space: /*#__PURE__*/ l.string(),
  targetPdsDid: /*#__PURE__*/ l.string({ format: 'did' }),
  targetActorDid: /*#__PURE__*/ l.string({ format: 'did' }),
  collection: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string({ format: 'nsid' }),
  ),
  expiresAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
})

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>

export const $output = /*#__PURE__*/ l.jsonPayload({
  id: /*#__PURE__*/ l.string({ maxLength: 64 }),
  token: /*#__PURE__*/ l.string({ maxLength: 256 }),
  space: /*#__PURE__*/ l.string(),
  targetPdsDid: /*#__PURE__*/ l.string({ format: 'did' }),
  targetActorDid: /*#__PURE__*/ l.string({ format: 'did' }),
  collection: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string({ format: 'nsid' }),
  ),
  expiresAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
  createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Create a narrowly scoped, expiring capability for one target PDS and actor to pull private records directly from this PDS. This is not a Relay credential. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output)

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
